module.exports = __webpack_public_path__ + "static/media/TIFF_Toronto.1b8bf28f.png";